import { useCallback } from 'react'

import { FEATURE } from 'constants/feature'
import { useAuthContext } from 'context/auth-provider'
import { checkPermission } from 'permissions/check-permission'

export const usePermission = () => {
  const { userRole } = useAuthContext()

  const canView = useCallback(
    (feature: FEATURE) => checkPermission(userRole, feature, 'view'),
    [userRole]
  )

  const canCRUD = useCallback(
    (feature: FEATURE) => checkPermission(userRole, feature, 'crud'),
    [userRole]
  )

  return { userRole, canView, canCRUD }
}
